// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"69433be5","377":"e462debd","696":"151a0c7d","816":"4a89f83b","913":"13672f77"}[chunkId] + ".chunk.js";
};